import type { Incident } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FormStack } from '../../components/forms/FormStack';
import { UserDescription } from '../../components/user/UserDescription';

interface Props {
  incident: Incident;
}

export const IncidentTeamCard = (props: Props) => {
  const { incident } = props;

  return (
    <ChakraV3.Card.Root h='full'>
      <ChakraV3.Card.Header>
        <ChakraV3.Stack gap={0}>
          <ChakraV3.Heading size='xl' fontWeight='bold'>
            Team members
          </ChakraV3.Heading>
          <ChakraV3.Text fontSize='sm' color='secondary'>
            The reviewer and reporter of this incident
          </ChakraV3.Text>
        </ChakraV3.Stack>
      </ChakraV3.Card.Header>
      <ChakraV3.Card.Body>
        <FormStack orientation='horizontal'>
          <ChakraV3.FormField label='Reporter' helperText='The person who reported this incident'>
            <UserDescription
              name={incident.reporter.name}
              secondary={incident.reporter.email}
              picture={incident.reporter.picture}
            />
          </ChakraV3.FormField>
          <ChakraV3.FormField
            label='Reviewers'
            helperText='The people assigned to review this incident'
          >
            <ChakraV3.Stack gap={4}>
              {incident.reviewers.map((reviewer) => {
                return (
                  <UserDescription
                    key={reviewer.id}
                    name={reviewer.name}
                    secondary={reviewer.email}
                    picture={reviewer.picture}
                  />
                );
              })}
            </ChakraV3.Stack>
          </ChakraV3.FormField>
        </FormStack>
      </ChakraV3.Card.Body>
    </ChakraV3.Card.Root>
  );
};
